/**
 * AudioStreamPlayer property formatter: the sections the details panel
 * shows. AudioStreamPlayer is non-spatial (no visual representation),
 * so it calls out the "not played in preview" status.
 */
import { audioMixingSection, audioStreamSection } from '../audioStreamSection';
export function formatAudioStreamPlayerProperties(properties) {
    return [audioStreamSection(properties), audioMixingSection(properties)];
}
//# sourceMappingURL=propertyFormatter.js.map